<style scoped lang="scss" type="text/scss">
    .content-component-container {
        display: flex;
        flex-direction: column;
        max-height: 100%;
        overflow: hidden;

        .content-wrap {
            position: relative;
            margin-top: 1rem;
            box-sizing: border-box;
            width: 100%;
            flex: 1;
            overflow: hidden;
        }

        .line-divider {
            margin-top: 1rem;
        }
    }
</style>

<template>
    <div class="content-component-container">
        <type-selector-panel></type-selector-panel>
        <line-divider class="line-divider"></line-divider>
        <div class="content-wrap">
            <router-view></router-view>
        </div>
    </div>
</template>

<script>
    import TypeSelectorPanel from './type-selector-panel';

    export default {
        name: '',
        components: {
            TypeSelectorPanel
        },
        data () {
            return {};
        },
        computed: {
            currentCompetitionId () {
                return this.$store.state.competition.currentCompetitionId;
            }
        },
        watch: {
            currentCompetitionId: {
                immediate: true,
                handler (currentCompetitionId) {
                    if (currentCompetitionId === null || currentCompetitionId === undefined) return;
                    this.$store.dispatch('player/loadCompetitionPlayers', {
                        competition_id: this.currentCompetitionId
                    }).then();
                    this.$store.dispatch('player/loadCompetitionCandidatePlayers', {
                        competition_id: this.currentCompetitionId
                    }).then();
                }
            }
        }
    };
</script>
